export default "__VITE_ASSET__CF9E39Lq__"